(function ($) {
  // On click arrow, open contact card
  $('.js-project-contact-card-opener').on('click', function () {
    $('.js-project-contact-card-container').fadeToggle();

    $(this).toggleClass('is-toggled');
  });

  // On click arrow, show inner form
  $('.js-project-contact-card-arrow').on('click', function () {
    $('.js-project-contact-card-form-hidden').fadeToggle();

    $(this).toggleClass('is-toggled');
  });

  // Close contact card
  $('.js-project-contact-card-close').on('click', function () {
    $('.js-project-contact-card-container').fadeOut();

    $('.js-project-contact-card-opener').removeClass('is-toggled');
  });
})(jQuery);
